import(/* webpackMode: "eager" */ "/app/code/build/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/code/build/packages/ui/src/button.tsx");
